import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * @typedef {object} ShippingRefs
 * @property {HTMLElement} message
 * @property {HTMLProgressElement | undefined} progress
 * @extends Component<ShippingRefs>
 */
class MsShippingProgress extends Component {
  #listeners;
  #request;
  #generation = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#listeners = new AbortController();
    if (this.hasAttribute('data-live')) {
      document.addEventListener(StandardEvents.cartLinesUpdate, this.#update, { signal: this.#listeners.signal });
      document.addEventListener(StandardEvents.cartDiscountUpdate, this.#update, { signal: this.#listeners.signal });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#listeners?.abort();
    this.#request?.abort();
    this.#generation++;
  }

  #update = async (event) => {
    const generation = ++this.#generation;
    this.#request?.abort();
    try {
      await event.promise;
      if (generation !== this.#generation || !this.isConnected) return;
      this.#request = new AbortController();
      const response = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' }, signal: this.#request.signal });
      if (!response.ok) return;
      const cart = await response.json();
      if (generation !== this.#generation || !this.isConnected) return;
      if (cart.currency !== this.dataset.currency) { this.hidden = true; return; }
      this.hidden = false;
      const threshold = Number(this.dataset.threshold);
      const remaining = Math.max(0, threshold - cart.total_price);
      const amount = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: cart.currency }).format(remaining / 100);
      this.refs.message.textContent = remaining ? this.dataset.remaining.replace('[amount]', amount) : this.dataset.qualified;
      if (this.refs.progress) this.refs.progress.value = Math.min(100, cart.total_price / threshold * 100);
    } catch (error) {
      // A rejected add or superseded refresh leaves the last confirmed subtotal intact.
      if (error.name !== 'AbortError') console.warn('[shipping-progress] Cart refresh failed');
    }
  };
}
if (!customElements.get('ms-shipping-progress')) customElements.define('ms-shipping-progress', MsShippingProgress);
